import { PupilService } from "@/services/pupil.service"
import { yearGroupMixin} from "@/mixins/yearGroupMixin.js";
import { mapGetters } from "vuex";
export const pupilMixin = {
    mixins: [yearGroupMixin],
    data() {
        return {
            pupilArray: [],
            classesArray: [],
            loading: false,
            errored: false,
            pupilsSelected: [],
        };
    },
    created() {
        this.fetchClasses();
        this.fetchPupilData()
    },
    computed: {
        ...mapGetters({

        }),
        pupilsLoaded() {
            return this.pupilArray != undefined && this.pupilArray.length > 0;
        },
        pupilArrayCount() {
            return this.pupilArray.length
        },
        pupilsSelectedCount() {
            return this.pupilsSelected.length
        },
    },
    methods: {
        fetchClasses() {
            PupilService.getClasses()
              .then((response) => this.buildClassList(response.data.data))
              .catch((err) => {
                console.log("classes " + err);
                this.errored = true;
              });
          },
          buildClassList(data) {
            this.classesArray = data.map(function (item, index) {
              return { id: index + 1, name: item };
            });
          },
        fetchPupilData() {
            this.loading = true
            PupilService.getAll()
                .then(response => this.buildPupilArray(response.data.data))
                .catch(err => {
                    console.log("Pupils " + err);
                    this.errored = true;
                })
                .finally(() => (this.loading = false));
        },
        buildPupilArray(data) {
            this.pupilArray = data;
           // this.pagination = data.meta.pagination;
        },
        isPupilSelected(pupil) {
            let found = this.pupilsSelected.find(
                (p) => p.identifier === pupil.identifier
              );
              return found  
        },
        filterPupils(years, types, classChosen) {
            if (years.length == 0 && types.length == 0 && classChosen.id == 0) {
                return _.orderBy(this.pupilArray, ["yeargroup", "class", "name"]);
            } else {
                var filtered = this.pupilArray.filter(function (pupil) {
                    let filtered = true;

                    if (years.length > 0) {
                        filtered = years.includes(pupil.yeargroup);
                    }

                    if (filtered) {
                        if (classChosen.id > 0) {
                            filtered = pupil.inclass === classChosen.name;
                        }
                    }

                    if (filtered) {
                        if (types.length > 0) {
                            if (types.includes("male")) {
                                filtered = pupil.gender.toLowerCase() == "male";
                            }
                             if (types.includes("female")) {
                                filtered = pupil.gender.toLowerCase() == "female";
                            }
                             if (types.includes("premium")) {
                                filtered = pupil.premium_pupil > 0;
                            }
                             if (types.includes("eal")) {
                                filtered = pupil.english_second > 0;
                            } 
                            if (types.includes("sen")) {
                                if (pupil.sen_status != null) {
                                    filtered =
                                    pupil.sen_status.startsWith("sen");
                                }
                               
                            }
                        }
                    }

                    return filtered;
                });

                return _.orderBy(filtered, ["yeargroup", "class", "name"]);
            }
        },

    }
};
